
import { useState, useEffect } from "react";
// import {
//   Bars3Icon,
//   XMarkIcon,
// } from "@heroicons/react/24/outline";
import {

  HomeIcon,
  // WrenchScrewdriverIcon,
  PhotoIcon,
  StarIcon,
} from "@heroicons/react/24/outline";

const MakeupIcon = ({ className = "w-5 h-5" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="1.5"
    className={className}
  >
    {/* Makeup brush */}
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.5 3.5l6 6"
    />

    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13 5l6 6"
    />

    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18.5 10.5l-7.8 7.8"
    />

    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.7 18.8l-3.2 1.7-3-3 1.7-3.2"
    />

    {/* Makeup compact */}
    <circle
      cx="7"
      cy="7"
      r="3.5"
    />

    <path
      strokeLinecap="round"
      d="M4.5 9.5L9.5 4.5"
    />
  </svg>
);
const links = [
  {href:"/",label:"Home"},
  { href: "#services", label: "Services" },
  { href: "#portfolio", label: "Portfolio" },
  { href: "#testimonials", label: "Reviews" },
];
const mobileBottomLinks = [
  {
    href: "/",
    label: "Home",
    icon: HomeIcon,
  },
  {
    href: "#services",
    label: "Services",
    icon: MakeupIcon,
  },
  {
    href: "#portfolio",
    label: "Portfolio",
    icon: PhotoIcon,
  },
  {
    href: "#testimonials",
    label: "Reviews",
    icon: StarIcon,
  },
];
const instagramUrl =
  "https://www.instagram.com/sreesunrisemakeup?igsh=MTkxcXpoZml2bW80cw==";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
const [activeSection, setActiveSection] = useState("home");
 useEffect(() => {
  const onScroll = () => {
    setScrolled(window.scrollY > 10);

    const sections = [
      { id: "home", href: "/" },
      { id: "services", href: "#services" },
      { id: "portfolio", href: "#portfolio" },
      { id: "testimonials", href: "#testimonials" },
    ];

    let currentSection = "home";

    sections.forEach((section) => {
      if (section.id === "home") return;

      const element = document.getElementById(section.id);

      if (element) {
        const rect = element.getBoundingClientRect();

        if (rect.top <= 180 && rect.bottom >= 180) {
          currentSection = section.id;
        }
      }
    });

    // Home detection
    if (window.scrollY < 200) {
      currentSection = "home";
    }

    setActiveSection(currentSection);
  };

  window.addEventListener("scroll", onScroll);

  // Initial load
  onScroll();

  return () => {
    window.removeEventListener("scroll", onScroll);
  };
}, []);

  // Close mobile menu when clicking a navigation link

  const handleLinkClick = (section) => {
  setOpen(false);
  setActiveSection(section);
};

  return (
    <>
      {/* Fixed Navbar */}
      <header
        className={`
          fixed
          top-0
          left-0
          right-0
          w-full
          z-[100]
          transition-all
          duration-300
          ${
            scrolled
              ? "backdrop-blur-xl bg-black/70 border-b border-white/10 shadow-lg"
              : "bg-black/20 backdrop-blur-md"
          }
        `}
      >
        <div className="section h-20 flex items-center justify-between">
          {/* Logo */}
          <a
            href="/"
            className="flex items-center shrink-0"
            aria-label="Sree Sunrise Studio Home"
          >
            <img
              src="/images/sun-logo.png"
              alt="Sree Sunrise Studio Logo"
              className="h-14  rounded-full object-cover"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
       {links.map((link) => {
  const sectionName =
    link.href === "/" ? "home" : link.href.replace("#", "");

  return (
    <a
      key={link.href}
      href={link.href}
      onClick={() => handleLinkClick(sectionName)}
      className={`
        relative
        text-sm lg:text-base
        transition-all
        duration-300
        pb-2
        ${
          activeSection === sectionName
            ? "text-amber-400"
            : "text-white/80 hover:text-amber-300"
        }
      `}
    >
      {link.label}

      {/* Active Sunlight Line */}
      {activeSection === sectionName && (
        <span
          className="
            absolute
            left-0
            bottom-0
            w-full
            h-[2px]
            rounded-full
            bg-gradient-to-r
            from-yellow-300
            via-amber-400
            to-orange-500
            shadow-[0_0_10px_rgba(251,191,36,0.9)]
          "
        />
      )}
    </a>
  );
})}

            {/* Instagram */}
            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Instagram"
              title="Follow us on Instagram"
              className="
                w-10 h-10
                rounded-full
                bg-gradient-to-tr
                from-yellow-400
                via-pink-500
                to-purple-600
                text-white
                flex
                items-center
                justify-center
                shadow-lg
                shadow-pink-500/20
                transition
                hover:scale-110
              "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="1.8"
                className="w-5 h-5"
              >
                <rect
                  x="3"
                  y="3"
                  width="18"
                  height="18"
                  rx="5"
                />

                <circle
                  cx="12"
                  cy="12"
                  r="4"
                />

                <circle
                  cx="17.5"
                  cy="6.5"
                  r="1"
                  fill="currentColor"
                  stroke="none"
                />
              </svg>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          {/* <button
            type="button"
            className="
              md:hidden
              p-2.5
              rounded-lg
              bg-white/10
              border
              border-white/10
              hover:bg-white/20
              transition
            "
            onClick={() => setOpen((value) => !value)}
            aria-label={
              open ? "Close navigation menu" : "Open navigation menu"
            }
            aria-expanded={open}
          >
            {open ? (
              <XMarkIcon className="w-6 h-6" />
            ) : (
              <Bars3Icon className="w-6 h-6" />
            )}
          </button> */}
        </div>

        {/* Mobile Menu */}
        {open && (
          <div className="md:hidden border-t border-white/10">
            <div className="section py-4">
              <div className="glass rounded-2xl p-4">
                {links.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={handleLinkClick}
                    className="
                      block
                      px-3
                      py-3
                      rounded-lg
                      text-white/90
                      hover:text-white
                      hover:bg-white/10
                      transition
                    "
                  >
                    {link.label}
                  </a>
                ))}

                {/* Mobile Instagram */}
                <a
                  href={instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleLinkClick}
                  className="
                    mt-4
                    w-full
                    flex
                    items-center
                    justify-center
                    gap-2
                    rounded-xl
                    bg-gradient-to-tr
                    from-yellow-400
                    via-pink-500
                    to-purple-600
                    text-white
                    py-3
                    px-5
                    font-medium
                    shadow-lg
                    shadow-pink-500/20
                    transition
                    hover:scale-[1.02]
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    className="w-5 h-5"
                  >
                    <rect
                      x="3"
                      y="3"
                      width="18"
                      height="18"
                      rx="5"
                    />

                    <circle
                      cx="12"
                      cy="12"
                      r="4"
                    />

                    <circle
                      cx="17.5"
                      cy="6.5"
                      r="1"
                      fill="currentColor"
                      stroke="none"
                    />
                  </svg>

                  Follow us on Instagram
                </a>
              </div>
            </div>
          </div>
        )}
      </header>
      {/* ================= Mobile Bottom Navigation ================= */}
<nav
  className="
    md:hidden
    fixed
    bottom-0
    left-0
    right-0
    z-[110]
    bg-black/90
    backdrop-blur-xl
    border-t
    border-white/10
    shadow-[0_-5px_25px_rgba(0,0,0,0.35)]
    px-2
    pb-[env(safe-area-inset-bottom)]
  "
>
  <div className="max-w-md mx-auto h-16 flex items-center justify-around">
    {mobileBottomLinks.map((item) => {
      const Icon = item.icon;

      return (
       <a
  key={item.href}
  href={item.href}
  onClick={() =>
    handleLinkClick(
      item.href === "/"
        ? "home"
        : item.href.replace("#", "")
    )
  }
  className={`
    relative
    flex
    flex-col
    items-center
    justify-center
    gap-1
    w-1/4
    h-full
    transition-all
    duration-300
    ${
      activeSection ===
      (item.href === "/" ? "home" : item.href.replace("#", ""))
        ? "text-amber-400"
        : "text-white/50 hover:text-amber-300"
    }
  `}
>
          <Icon className="w-5 h-5" />

          <span className="text-[11px] font-medium">
            {item.label}
          </span>
        </a>
      );
    })}
  </div>
</nav>

      {/* Navbar Space */}
      <div className="h-20" />
    </>
  );
}
